var _excluded = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { IndexContext } from "../lib/IndexContext.js";
import { InstantSearchContext } from "../lib/InstantSearchContext.js";
import { useInstantSearchApi } from "../lib/useInstantSearchApi.js";
export function InstantSearch(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var search = useInstantSearchApi(props);
  if (!search.started) {
    return null;
  }
  return /*#__PURE__*/React.createElement(InstantSearchContext.Provider, {
    value: search
  }, /*#__PURE__*/React.createElement(IndexContext.Provider, {
    value: search.mainIndex
  }, children));
}